<template>
  <div>
    <h2 v-text="$t('Approvals')" />
    <WdsText
      large
      :text="$t('Review all pending and completed requests for your groups')"
      tertiary
    />
    <div class="tw-mt-4 tw-flex tw-justify-between tw-items-center">
      <div class="tw-flex tw-items-center tw-space-x-2">
        <WdsText large :text="`${$t('My groups')} :`" primary />

        <WdsTagGroup
          v-if="!loading && userGroups"
          :tags="userGroups.map((group) => ({ label: group.name }))"
          :max-tags="maxTags"
          @click:plus="maxTags = Number.MAX_VALUE"
        />
      </div>
      <!--      <a class="tw-text-lg" href="#" v-text="$t('Learn more about approvals')" />-->
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import { WdsTagGroup, WdsText } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const { result, loading } = useQuery(
  gql`
    query ApproverDashboardHeaderUserGroups(
      $page: Int
      $first: Int!
      $accounts: [ID!]
      $users: [ID!]
    ) {
      userGroups(page: $page, accounts: $accounts, users: $users, first: $first) {
        data {
          name
        }
      }
    }
  `,
  () => ({
    page: 1,
    first: 15,
    accounts: [currentAccount.globalId],
    users: [currentUser.globalId],
  }),
  {
    clientId: 'publicApi',
    debounce: 100,
  },
)

const maxTags = ref(2)
const userGroups = computed(() => result?.value?.userGroups?.data || null)
</script>
